import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let QuestionSetScore = class QuestionSetScore extends Vue {
    get disabled() {
        // return this.paperInfo.participateCount > 0 || this.isRandomSetType
        return this.isRandomSetType;
    }
    get isRandomSetType() {
        // var e = this
        //   , t = !1
        //   , n = this.item;
        // 1 == this.baseInfo.question_random ? this.baseInfo.ran_details.forEach((function (r) {
        //   1 == n.isMaterialQuestion ? r.type == e.materialItem.type && r.num > 0 && (t = !0) : r.type == n.type && r.num > 0 && (t = !0)
        // }
        // )) : t = !1
        // return t
        return false;
    }
    disableClickInfo() {
        // if (this.disabled) {
        //   if (this.paperInfo.participateCount > 0)
        //     return this.$message.error("有人参与的试卷禁止修改分数");
        //   if (this.isRandomSetType)
        //     return this.$message.error("随机试卷选中的题型禁止修改分数")
        // }
        if (this.isRandomSetType)
            return this.$message.error("随机试卷选中的题型禁止修改分数");
    }
    changeOmit(question, omitType) {
        // this.paperInfo.participateCount > 0
        //   ? this.$message.error("有人参与的试卷禁止修改分数")
        //   : this.isRandomSetType
        //     ? this.$message.error("随机试卷选中的题型禁止修改分数")
        //     : this.$emit("change-omit", question, omitType)
        this.isRandomSetType
            ? this.$message.error("随机试卷选中的题型禁止修改分数")
            : this.$emit("change-omit", question, omitType);
    }
    watchInput(question, evt, omitType) {
        question.isMaterialQuestion
            ? this.$emit("watch-input", question, evt, omitType, this.materialQuestion)
            : this.$emit("watch-input", question, evt, omitType);
    }
    changeScore(question) {
        this.$emit("change-score", question);
    }
};
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], QuestionSetScore.prototype, "question", void 0);
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], QuestionSetScore.prototype, "materialQuestion", void 0);
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], QuestionSetScore.prototype, "paperInfo", void 0);
QuestionSetScore = tslib_1.__decorate([
    Component({
        name: 'QuestionSetScore',
    })
], QuestionSetScore);
export default QuestionSetScore;
